import { combineReducers } from "@reduxjs/toolkit";

import prizes from "./prizes/slice";

export default combineReducers({
  prizes,
});
